import React from 'react';
export const SoundControl = ({ isMuted, onToggleMute }) => {
  const handleToggle = () => {
    onToggleMute();
  };

  return (
    <button
      onClick={handleToggle}
      className={`control-btn ${isMuted ? 'opacity-50' : ''}`}
      title={isMuted ? 'Sesi Aç' : 'Sesi Kapat'}
    >
      {isMuted ? '🔇' : '🔊'}
      {window.innerWidth > 480 && (
        <span>{isMuted ? ' Ses Kapalı' : ' Ses Açık'}</span>
      )}
    </button>
  );
};